import {
			ItemDetailsAuthors2,
			ItemDetailsAuthors3,
			ItemDetailsAuthors4,
			ItemDetailsAuthors5
		} from '../../utils/allImgs'

export const data = [
	{
		img:ItemDetailsAuthors2,
		text:'Wadee-Nel',
		bid:0.212,
		time:'12:59',
		addMargin:false
	},
	{
		img:ItemDetailsAuthors3,
		text:'Johan Donem',
		bid:0.321,
		time:'11:39',
		addMargin:false
	},
	{
		img:ItemDetailsAuthors4,
		text:'Morgan Wright',
		bid:0.215,
		time:'11:34',
		addMargin:false
	},
	{
		img:ItemDetailsAuthors5,
		text:'Amillia Nnor',
		bid:0.118,
		time:'10:55',
		addMargin:true
	},
]

export const details = [
	{
		text1:'Artist',
		text2:'LarySmith-30'
	},
	{
		text1:'Size',
		text2:'3000 x 300'
	},
	{
		text1:'Created',
		text2:'04 April , 2021'
	},
	{
		text1:'Collection',
		text2:'Cyberpunk City Art'
	}
]

// export {data , details}